export function LogoType({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 760 150"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Hytch Trigger"
    >
      <rect
        x="8"
        y="18"
        width="112"
        height="112"
        rx="28"
        fill="url(#hytch-trigger-mark-bg)"
      />
      <path d="M36 99V49h17v19h26V49h17v50H79V80H53v19H36Z" fill="white" />
      <path d="M91 35l-8 21h15L80 87l5-23H71l20-29Z" fill="#FACC15" />
      <text
        x="145"
        y="91"
        fill="url(#hytch-trigger-wordmark)"
        fontFamily="Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        fontSize="62"
        fontWeight="800"
        letterSpacing="-2.5"
      >
        Hytch Trigger
      </text>
      <defs>
        <linearGradient
          id="hytch-trigger-mark-bg"
          x1="8"
          y1="18"
          x2="120"
          y2="130"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0F172A" />
          <stop offset="0.48" stopColor="#2563EB" />
          <stop offset="1" stopColor="#06B6D4" />
        </linearGradient>
        <linearGradient
          id="hytch-trigger-wordmark"
          x1="145"
          y1="28"
          x2="628"
          y2="118"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E0F2FE" />
          <stop offset="0.55" stopColor="#60A5FA" />
          <stop offset="1" stopColor="#22D3EE" />
        </linearGradient>
      </defs>
    </svg>
  );
}
